import { useEffect, useMemo } from "react";
import { QRCodeSVG } from "qrcode.react";
import {
  APP_DOWNLOAD_URL,
  APP_STORE_URL,
  GOOGLE_PLAY_URL,
  detectAppPlatform,
  storeUrlForPlatform,
} from "./appLinks";

export default function DownloadRedirect() {
  const platform = useMemo(() => detectAppPlatform(), []);
  const downloadUrl =
    typeof window === "undefined" ? APP_DOWNLOAD_URL : window.location.href;

  useEffect(() => {
    document.title = "Download Evo - AI Grading for TCG Cards";

    if (platform === "desktop") return;

    window.location.href = storeUrlForPlatform(platform);
  }, [platform]);

  const isDesktop = platform === "desktop";
  const primaryUrl = platform === "android" ? GOOGLE_PLAY_URL : APP_STORE_URL;
  const headline =
    platform === "android"
      ? "Opening Evo in Google Play..."
      : platform === "ios"
        ? "Opening Evo in the App Store..."
        : "Download Evo";

  return (
    <main className="min-h-screen bg-[#f8f7f6] px-5 py-8 text-[#07001a]">
      <section className="mx-auto flex min-h-[calc(100vh-64px)] max-w-[520px] flex-col items-center justify-center text-center">
        <img
          alt="Evo"
          className="mb-8 h-auto w-[118px]"
          src="/evo-logo-full.svg"
        />
        <h1 className="font-['Figtree',sans-serif] text-[34px] font-black leading-[1.1] sm:text-[40px]">
          {headline}
        </h1>
        <p className="mt-4 max-w-[370px] font-['Figtree',sans-serif] text-[16px] font-bold leading-[1.5] text-[#332e3f]">
          AI card grading for Pokémon & TCG cards.
        </p>
        <p className="mt-3 max-w-[360px] font-['Figtree',sans-serif] text-[14px] font-semibold leading-[1.5] text-[#665f73]">
          Grade cards from two photos. Check centering, damage, and estimated
          grade before you submit.
        </p>

        {isDesktop ? (
          <div className="mt-8 rounded-[20px] bg-white p-4 shadow-[0px_3px_3.5px_rgba(0,0,0,0.05)]">
            <QRCodeSVG
              value={downloadUrl}
              size={156}
              bgColor="#ffffff"
              fgColor="#07001a"
              level="M"
            />
          </div>
        ) : null}

        <a
          className="mt-8 flex w-full max-w-[340px] items-center justify-center rounded-[12px] bg-[#141221] px-5 py-4 font-['Figtree',sans-serif] text-[16px] font-black text-white no-underline"
          href={primaryUrl}
        >
          Download Evo Free
        </a>

        {isDesktop ? (
          <div className="mt-4 flex w-full max-w-[360px] flex-col gap-3 sm:flex-row">
            <a
              className="flex flex-1 items-center justify-center rounded-[12px] bg-white px-5 py-4 font-['Figtree',sans-serif] text-[15px] font-black text-[#07001a] no-underline shadow-[0px_3px_3.5px_rgba(0,0,0,0.05)]"
              href={APP_STORE_URL}
            >
              App Store
            </a>
            <a
              className="flex flex-1 items-center justify-center rounded-[12px] bg-white px-5 py-4 font-['Figtree',sans-serif] text-[15px] font-black text-[#07001a] no-underline shadow-[0px_3px_3.5px_rgba(0,0,0,0.05)]"
              href={GOOGLE_PLAY_URL}
            >
              Google Play
            </a>
          </div>
        ) : null}

        <noscript className="mt-4 flex w-full max-w-[360px] flex-col gap-3 sm:flex-row">
          <a
            className="flex flex-1 items-center justify-center rounded-[12px] bg-white px-5 py-4 font-['Figtree',sans-serif] text-[15px] font-black text-[#07001a] no-underline shadow-[0px_3px_3.5px_rgba(0,0,0,0.05)]"
            href={APP_STORE_URL}
          >
            App Store
          </a>
          <a
            className="flex flex-1 items-center justify-center rounded-[12px] bg-white px-5 py-4 font-['Figtree',sans-serif] text-[15px] font-black text-[#07001a] no-underline shadow-[0px_3px_3.5px_rgba(0,0,0,0.05)]"
            href={GOOGLE_PLAY_URL}
          >
            Google Play
          </a>
        </noscript>
      </section>
    </main>
  );
}
